import * as React from 'react';
import { TOKEN_BEARER, TOKEN_EXPIRATION } from '../../constants/storageKeys';
import logger from '../../utils/logger';

const AuthComplete: React.FC = () => {
    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const expires = params.get('expires');

        if (token && expires) {
            logger.info('Entra login succeeded, storing token and redirecting');
            localStorage.setItem(TOKEN_BEARER, token);
            localStorage.setItem(TOKEN_EXPIRATION, expires);
            window.location.replace('/');
        } else {
            logger.warn('Entra auth callback received but token or expires was missing');
        }
    }, []);

    return <div>Signing in...</div>;
};

export default AuthComplete;
